document.querySelector('.facts_btn').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('.image-popup').style.display = 'flex';
  document.querySelector('body').setAttribute('style','overflow:hidden;');
});
document.querySelector('.image-popup').addEventListener('click', function(event) {
  const popupInner = document.querySelector('.popup-inner');
  const closeIcon = document.querySelector('.close-icon');
  if (!popupInner.contains(event.target) || closeIcon.contains(event.target)) {
    document.querySelector('.image-popup').style.display = 'none';
    document.querySelector('body').removeAttribute('style');
  }
});
function checkWindowHeight() {
  let popupInner = document.querySelector('div[data-block-type="description"] div.image-popup > div.popup-inner');
  if (window.innerHeight < 750) {
    let mwidth = window.innerHeight * .75;
    popupInner.setAttribute('style','max-width:'+mwidth+'px');
  } else popupInner.setAttribute('style','max-width:600px');
}
document.addEventListener('DOMContentLoaded', checkWindowHeight);
window.addEventListener('resize', checkWindowHeight);